import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'formatKey' })
export class FormatKeyPipe implements PipeTransform {

  transform(key: string): string {
    return key.split('_')
            .map(word => word ? (word[0].toUpperCase() + word.slice(1)) : word)
            .join(' ');
  }
}
